export const TRANSLATIONS_AR = {
  Copyright: "",
  all_rights_reserved: "جميع حقوق الطبع والنشر لدي",
  menu_title_home: "الرئيسية",
  menu_title_who_we_are: "من نحن",
  menu_title_about_us: "عن الشركة",
  menu_title_vision: "رؤيتنا",
  menu_title_members: "مجلس الإدارة",
  menu_title_partners: "شركاء النجاح",
  menu_title_shareholders: "المساهمين",
  menu_title_coupons: "صرف الكوبونات",
  menu_title_issues: "الإصدارات",
  issue: "الإصدار رقم. ",
  menu_title_contact_us: "اتصل بنا",
  language: "EN",
  home_page_title_pt1: "خبراء",
  home_page_title_pt2: "التوريق في",
  home_page_title_pt3: "مصر",
  coupons_pt1: "صرف",
  coupons_pt2: "الكوبونات",
  about_us_pt1: "الشركة",
  about_us_pt2: "عن",
  about_us_text:
    "تأسست شركة كابيتال للتوريق -شركة مساهمة مصرية – وفقاً لأحكام القانون\n رقم 95 لسنة  1992 ولائحته التنفيذية، وبموجب قرار لجنة تأسيس الشركات\n.بالهيئة العامة للرقابة المالية بجلستها رقم 314 بتاريخ 26 ديسمبر 2018\n\n.وتم قيدها في السجل التجاري تحت رقم 245129 بتاريخ 8 يناير 2019\n\nتباشر الشركة أعمالها منذ أربعة أعوام في مجال توريق الحقوق المالية\nالآجلة في السوق المحلي المصري، وذلك بالتعاون مع أكبر البنوك المصرية\n والمؤسسات، مثل شركة مصر للمقاصة والإيداع والقيد المركزي، والبورصة\n المصرية، وشركة ميريس للتصنيف الائتماني، وذلك تحت رقابة الهيئة العامة\n.للرقابة المالية والجهاز المركزي للمحاسبات",
  our_vision_pt1: "رؤيتنا",
  our_vision_pt2: "",
  our_vision_text:
    "أن تكون الشركة أكبر شركة توريق في مصر لتساهم في تنفيذ برامج\nتمويل المشروعات المصرية الضخمة في كل المجالات سواءاً على\nمستوى القطاع الحكومي أو على مستوى القطاع الخاص وفق منظومة\nقوية من القوانين والتشريعات والقرارات المنظمة للسوق\n.والصادرة عن هيئة الرقابة المالية",
  Partners_In_Success_pt1: "شركاء ",
  Partners_In_Success_pt2: "النجاح",
  board_member_pt1: "مجلس ",
  board_member_pt2: "الإدارة",
  shareholders: "المساهمين",
  Shares: "عدد الأسهم",
  The_value_in_Egyptian_pounds: "القيمة الإسمية بالجنيه المصري",
  Currency_fulfilled: "العملة التي تم الوفاء بها",
  The_Ratio: "النسبة",
  read_more: "اقرأ المزيد",
  Total_Amount: "بمبلغ إجمالي",
  Issuance_Date: "تاريخ الإصدار",
  Maturity_Date: "تاريخ الإستحقاق",
  Interest_Rate: "سعر العائد",
  Portfolio_Referrer: "محيل المحفظة",
  Custodian: "أمين الحفظ",
  Collector: "المحصل",
  The_nominal_value_of_the_bonds_upon_issuance:
    "القيمة الإسمية للسندات عند الإصدار",
  Through_Misr_for_Central_clearing:
    "عن طريق شركة مصر للمقاصة و الايداع و القيد المركزى",

  contact_us_pt1: "بنا ",
  contact_us_pt2: "اتصل",
  Full_Name: "الأسم",
  phone: "رقم التليفون",
  Email: "البريد الإلكتروني",
  Subject: "الموضوع",
  how_help_you: "كيف بمكننا مساعدتك؟",
  submit_btn: "إرسال",
  alert_name: "لا يجوز أن يكون الاسم فارغًا",
  alert_Phone: "لا يمكن أن يكون الهاتف فارغًا",
  alert_Email: "لا يجوز أن يكون البريد الإلكتروني فارغًا",
  alert_Subject: "لا يجوز أن يكون الموضوع فارغًا",
  alert_Comment: "لا يجوز أن يكون التعليق فارغًا",
  Successfully_sent_message: "تم إرسال الرسالة بنجاح!",
  failed_sent_message: "فشل في إرسال البريد الإلكتروني!",
};
